import Component from "vue-class-component";
import Vue from 'vue';
import { loadsearchDataForSoftbook } from '@/models/UtilService';
import ProductLinkSoftbook from '@/components/index-viewport-components/ProductLinkSoftbook';

@Component({
components:{
    'prod-link-softbook':ProductLinkSoftbook
  }
})
export default class SoftbooksSearchResultPage extends Vue
{

    constructor(){
        super();
    }

     searchTerm:string='Search Term on Page';
     resultManualListe:any[]=[];
       
    beforeRouteUpdate (to, from, next) {
        //console.log('BEFORE ROUTE UPDATE CALLED');

        this.searchTerm = this.$route.params.searchterm;
        next();
        //console.log('BEFORE ROUTE UPDATE CALLED');
      }

     created(){
         this.searchTerm = this.$route.params.searchterm;

         this.resultManualListe = loadsearchDataForSoftbook(this.searchTerm,'DE');
        }

        productRouterLink(prodId:string):string{
          return `/${this.$i18n.locale}/product/${prodId}`;
        }


}


